module.exports = __webpack_public_path__ + "img/no_book_cover.c3b7c27a.png";